/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Order_Detail_EmptyInputs */

const vi_station_order_detail_empty = /** @type {(inputs: Station_Order_Detail_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn này chưa có sản phẩm`)
};

/**

* @param {Station_Order_Detail_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_order_detail_empty = /** @type {((inputs?: Station_Order_Detail_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Order_Detail_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_order_detail_empty(inputs)
});